import React, { useState } from 'react'
import { DownOutlined } from '@ant-design/icons'

/**
 * A framed block inside an expanded run. The expanded row holds more than one
 * of these, so each needs its own edge to keep them apart.
 *
 * A section can start collapsed: the processing steps only apply to the API
 * integration, and on any run they are a long list that pushes the timeline —
 * the part most readers came for — below the fold.
 */
function Section({
  title,
  extra,
  startCollapsed = false,
  children,
}: {
  title: string
  /** Summary figures for the section, shown on the right of its header. */
  extra?: React.ReactNode
  startCollapsed?: boolean
  children: React.ReactNode
}) {
  const [isOpen, setIsOpen] = useState(!startCollapsed)

  return (
    <section
      style={{
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 8,
        marginBottom: 16,
      }}
    >
      <div
        onClick={startCollapsed ? () => setIsOpen(!isOpen) : undefined}
        style={{
          padding: '12px 20px',
          borderBottom: isOpen ? '1px solid #f1f2f4' : 'none',
          fontWeight: 600,
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          gap: 24,
          cursor: startCollapsed ? 'pointer' : undefined,
        }}
      >
        <span>
          {startCollapsed && (
            <DownOutlined
              style={{
                marginRight: 8,
                fontSize: 11,
                color: '#9ca3af',
                transition: 'transform 160ms ease',
                transform: isOpen ? 'none' : 'rotate(-90deg)',
              }}
            />
          )}
          {title}
        </span>
        {extra}
      </div>
      {isOpen && <div style={{ padding: '4px 20px 16px' }}>{children}</div>}
    </section>
  )
}

export default Section
